import * as React from "react";
import { RendererProps } from "@jsonforms/core";
import { ResolvedJsonFormsDispatch, useJsonForms, withJsonFormsLayoutProps } from "@jsonforms/react";
import { GroupLayout as IGroupLayout } from "@jsonforms/core/lib/models/uischema";
import { VerticalLayoutWrapper } from "../../styles";

const VerticalLayout: React.FC<RendererProps> = ({ uischema, path, schema, visible }) => {
	const { elements } = uischema as IGroupLayout;

	const { renderers, cells } = useJsonForms();

	if (!visible) {
		return null;
	}

	return (
		<VerticalLayoutWrapper>
			{elements.map((child, index) => (
				<ResolvedJsonFormsDispatch
					renderers={renderers}
					cells={cells}
					uischema={child}
					schema={schema}
					path={path}
					key={`${path}-${index}`}
				/>
			))}
		</VerticalLayoutWrapper>
	);
};

export default withJsonFormsLayoutProps(VerticalLayout);
